import XButton from 'vux/src/components/x-button/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'


export default {
name: 'noPictureQuote',
components: {
XButton,
ButtonTab,
ButtonTabItem
},
data () {
return {
showWeight: false
}
},
methods: {
volume () {
this.showWeight = false
},
weight () {
this.showWeight = true
}
},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/noPictureQuote/script.js